<script>
  import './styles.scss';
  import { Router, Link, Route } from 'svelte-routing';
  import About from './About.svelte';
  import Projects from './projects/Projects.svelte';
  import WorkExperience from './work/WorkExperience.svelte';

  import { HeaderBar, NavBar, PageNotFound, Redirect } from './components';

  export let url = '';
</script>

<HeaderBar />
<div class="section columns">
  <Router {url}>
    <NavBar />
    <main class="column">
      <div>
        <Route path="/">
          <Redirect path="/about" />
        </Route>
        <Route path="/projects" component={Projects} />
        <Route path="/about" component={About} />
        <Route path="/experience" component={WorkExperience} />
        <Route path="**" component={PageNotFound} />
      </div>
    </main>
  </Router>
</div>
